import React from "react";
import styled from "styled-components";

const Section = styled.section`
  padding: 4rem 2rem;
  background: #0f0f0f;
`;

const Title = styled.h2`
  text-align: center;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 2rem;
  font-size: 2.2rem;
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 700px;
  margin: auto;
`;

const Step = styled.div`
  background: ${({ theme }) => theme.glass};
  padding: 1.5rem;
  border-left: 5px solid ${({ theme }) => theme.secondary};
  border-radius: 8px;
  color: #ccc;
`;

export default function HowItWorks() {
  return (
    <Section>
      <Title>How It Works</Title>
      <Steps>
        <Step>1️⃣ User posts a real code issue with optional reward.</Step>
        <Step>2️⃣ Solvers pick issues, provide tested solutions.</Step>
        <Step>3️⃣ On acceptance, solver earns rewards and gets rated.</Step>
        <Step>
          4️⃣ Leaderboard + profile builds over time. Freelance + job
          opportunities open.
        </Step>
      </Steps>
    </Section>
  );
}
